<template>
  <div
    class="progress"
    :class="customClass"
    :aria-valuenow="value"
    aria-valuemin="0"
    :aria-valuemax="total"
  >
    <div
      class="progress-bar"
      :style="`width: ${value*100/total}%`"
    />
  </div>
</template>

<script>
/**
 * Affiche une jauge de progression.
 * La couleur est à surdéfinir selon les besoins dans les différents projets.
 */
export default {
  name: "ProgressBar",
  props: {
    /**
     * Valeur actuelle de progression.
     */
    value: {
      type: Number,
      default: 0,
    },
    /**
     * Valeur de la progression maximale (100%).
     */
    total: {
      type: Number,
      default: 100,
    },
    /**
     * Rajoute une classe sur la barre de progression.
     */
    customClass: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss">
@use "../../assets/styles/_variables.scss" as var;

.progress {
  padding: 0.2rem;
  width: var.$space-x-large;
  height: var.$space-tiny;
  background-color: var.$white;
  border-radius: var.$space-small;
  border: 1px solid var.$blue-16;
  border-radius: var.$space-small;

  &.positive .progress-bar { background-color: var.$positive; }
  &.warning .progress-bar { background-color: var.$warning; }
  &.negative .progress-bar { background-color: var.$negative; }

  .progress-bar { border-radius: var.$space-small; }
}
</style>
